module.exports = __webpack_public_path__ + "static/media/change_image_icon.587afc75.svg";